import * as z from 'zod/v4';

export const competitionIdSchema = z.number().brand<'CompetitionId'>();
export type CompetitionId = z.infer<typeof competitionIdSchema>;
